package com.dignicate.web.domain

/**
 * Domain-level Technology category (string-based)
 */
enum class TechnologyCategory {
    MOBILE,
    BACKEND,
    PROCESS
}

data class CompanyContent(
    val companyName: String,
    val items: List<Item>
) {
    data class Item(
        val label: String,
        val sublabel: String? = null,
        val value: String
    )
}

/**
 * Hero セクションのコンテンツ (string-based, resolved in repository/usecase)
 */
data class HeroContent(
    val title: String,
    val subtitle: String
)

/**
 * About セクションのコンテンツ
 */
data class AboutContent(
    val description: String,
    val imageUrl: String? = null
)

/**
 * Product info (domain-level)
 */
data class ProductInfo(
    val id: String,
    val title: String,
    val description: String,
    // optional store links: null when not available
    val androidLink: String? = null,
    val iosLink: String? = null
)

/**
 * Value statement (domain-level)
 */
data class ValueStatement(
    val id: String,
    val title: String,
    val body: String
)

/**
 * Technology area (domain-level, string fields)
 */
data class TechnologyArea(
    val id: String,
    val category: TechnologyCategory,
    val title: String,
    val description: String
)

/**
 * メイン画面全体のコンテンツ
 * 各セクションのコンテンツをまとめて保持
 */
data class MainPageContent(
    val pageId: String = "main",
    val hero: HeroContent,
    val about: AboutContent,
    val technologies: List<TechnologyArea> = emptyList(),
    val products: List<ProductInfo> = emptyList(),
    val values: List<ValueStatement> = emptyList(),

    // Section headings / intro texts (provided by repository)
    val technologiesTitle: String = "",
    val technologiesDescription: String = "",
    val productsTitle: String = "",
    val productsDescription: String = "",
    val valuesTitle: String = "",
    val valuesDescription: String = "",
)

data class LinkItem(
    val label: String,
    val url: String,
)

data class PrivacyPolicyContent(
    val title: String,
    val introParagraphs: List<String>,
    val sections: List<PrivacyPolicySection>,
    val effectiveDate: String?,
    val contactEmail: String?,
    val credits: List<String>
)

data class PrivacyPolicySection(
    val heading: String,
    val paragraphs: List<String> = emptyList(),
    val bullets: List<String> = emptyList(),
    val links: List<LinkItem> = emptyList(),
)
